export const root = "r1m6i6h9";
export const iconAnimationContainer = "i17uyace";
export const iconAnimation = "i1jhbuaw";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.tsx");